var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoblankmobileimages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 667,
    height: 545,
    viewBox: "0 0 667 545",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 348.963,
    y: 14.4504,
    width: 318.694,
    height: 660.844,
    rx: 41.1643,
    transform: "rotate(8.64559 348.963 14.4504)",
    fill: "#1C1B2D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 352.312,
    y: 19.0049,
    width: 309.702,
    height: 652.846,
    rx: 37.6241,
    transform: "rotate(8.64559 352.312 19.0049)",
    fill: "#23213B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 321.954,
    y: 172.145,
    width: 1.99808,
    height: 46.9889,
    rx: 0.884738,
    transform: "rotate(8.64559 321.954 172.145)",
    fill: "#1C1B2D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 313.087,
    y: 230.461,
    width: 1.99808,
    height: 46.9889,
    rx: 0.884738,
    transform: "rotate(8.64559 313.087 230.461)",
    fill: "#1C1B2D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 328.566,
    y: 128.655,
    width: 2.99712,
    height: 22.9946,
    rx: 0.884738,
    transform: "rotate(8.64559 328.566 128.655)",
    fill: "#1C1B2D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 635.181,
    y: 252.131,
    width: 2.99712,
    height: 72.9828,
    rx: 0.884738,
    transform: "rotate(8.64559 635.181 252.131)",
    fill: "#1C1B2D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 358.861,
    y: 29.1018,
    width: 292.719,
    height: 634.851,
    rx: 31.0294,
    transform: "rotate(8.64559 358.861 29.1018)",
    fill: "#353447"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 460.529,
    y: 51.6392,
    width: 85.9174,
    height: 24.9941,
    rx: 12.4971,
    transform: "rotate(8.64559 460.529 51.6392)",
    fill: "#1C1B2D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 2.98535,
    y: 28.7356,
    width: 318.694,
    height: 660.844,
    rx: 41.1643,
    transform: "rotate(-5.06 2.98535 28.7356)",
    fill: "#1C1B2D"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 7.31836,
    y: 32.3667,
    width: 309.702,
    height: 652.846,
    rx: 37.6241,
    transform: "rotate(-5.06 7.31836 32.3667)",
    fill: "#23213B"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1084,
    y: 188.339,
    width: 1.99808,
    height: 46.9889,
    rx: 0.884738,
    transform: "rotate(-5.06 14.1084 188.339)",
    fill: "#1C1B2D"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 19.3105,
    y: 247.095,
    width: 1.99808,
    height: 46.9889,
    rx: 0.884738,
    transform: "rotate(-5.06 19.3105 247.095)",
    fill: "#1C1B2D"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2285,
    y: 144.521,
    width: 2.99712,
    height: 22.9946,
    rx: 0.884738,
    transform: "rotate(-5.06 10.2285 144.521)",
    fill: "#1C1B2D"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 337.367,
    y: 191.834,
    width: 2.99712,
    height: 72.9828,
    rx: 0.884738,
    transform: "rotate(-5.06 337.367 191.834)",
    fill: "#1C1B2D"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 16.0732,
    y: 40.6245,
    width: 292.719,
    height: 634.851,
    rx: 31.0294,
    transform: "rotate(-5.06 16.0732 40.6245)",
    fill: "#353447"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 120.186,
    y: 38.4319,
    width: 85.9174,
    height: 24.9941,
    rx: 12.4971,
    transform: "rotate(-5.06 120.186 38.4319)",
    fill: "#1C1B2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoblankmobileimages);
export default __webpack_public_path__ + "static/media/twoblankmobileimages.9305393408cc0b6bcd9daa7f70fe9b83.svg";
export { ForwardRef as ReactComponent };